module.exports = __webpack_public_path__ + "assets/img/logos/amakids_ru.png";